import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiEndpoints } from "../../Utils/ApiConfig";
import {useSelector} from 'react-redux'
import { useEffect } from "react";

export const AuthenticationSlice = createSlice({
    name: "user",
    initialState: {
        loading: false,
        error: null,
        authenticated: false,
        accessToken: localStorage.getItem("ThrillionAccess") ||  null,
        refreshToken: localStorage.getItem("ThrillionRefresh") || null
    },

    reducers: {

        settingTokens(state, action) {
            if (action.payload) {
                state.loading = false
                state.authenticated = action.payload.authenticated
                state.error = false
                state.accessToken = action.payload.access
                state.refreshToken = action.payload.refresh
            }
            else {
                state.loading = false
                state.authenticated = false
                state.error = null
                state.accessToken = null
                state.refreshToken = null
            }
        },

        logoutFunction(state, action) {
            state.authenticated = action.payload
            state.accessToken = null
            state.refreshToken = null
        }
    },
})

export const { loginFunc, settingTokens } = AuthenticationSlice.actions;


export default AuthenticationSlice.reducer